import { render } from "./SubNavigation.vue?vue&type=template&id=72c7b3a7"
import script from "./SubNavigation.vue?vue&type=script&lang=js"
export * from "./SubNavigation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\rossc\\Desktop\\Mike\\Alldream Studios\\Presence\\Website\\Portfolio\\v10\\PortfolioSocialImpact\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__